module.exports = __webpack_public_path__ + "c1b2c23b385686d3d0eb5a81543cad5d.MP3";